var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 79,
    viewBox: "0 0 56 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-13 3L-8 7.25L-5.50044 8.57789C-1.88868 10.4966 2.13866 11.5 6.22844 11.5H10.5H44C47.3137 11.5 50 14.1863 50 17.5V55.5C50 58.8137 47.3137 61.5 44 61.5H10.5H5.9017C2.02057 61.5 -1.80725 62.4036 -5.27864 64.1393L-8 65.5L-13 69.5V3Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.1895C18.201 47.1895 13.5 42.4489 13.5 36.6011C13.5 30.7532 18.201 26.0126 24 26.0126C29.799 26.0126 34.5 30.7532 34.5 36.6011C34.5 42.4489 29.799 47.1895 24 47.1895ZM24 44.8365C28.5103 44.8365 32.1667 41.1494 32.1667 36.6011C32.1667 32.0528 28.5103 28.3656 24 28.3656C19.4897 28.3656 15.8333 32.0527 15.8333 36.6011C15.8333 41.1494 19.4897 44.8365 24 44.8365ZM22.3495 33.1216C21.9501 33.5243 21.9501 34.1773 22.3495 34.5801L24.3536 36.6011L22.3495 38.622C21.9501 39.0248 21.9501 39.6778 22.3495 40.0806C22.7489 40.4833 23.3965 40.4833 23.7959 40.0806L26.5232 37.3303C26.9226 36.9276 26.9226 36.2746 26.5232 35.8718L23.7959 33.1216C23.3965 32.7188 22.7489 32.7188 22.3495 33.1216Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_6621",
    x: -19,
    y: 0,
    width: 75,
    height: 78.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_6621"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_6621",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.95aac35c.svg";
export { ForwardRef as ReactComponent };